import React, { useEffect, useMemo } from 'react';
import GijgoGrid from '../../../../../Core/Controls/GijgoGrid';
import { BreadCrumbs, DeleteButton, EditButton, formatters } from '../../../../../Core/Controls';
import { AppStorage } from '../../../../../Core/Basic/storage-service';
import DialogComp from '../../../../../Core/Dialog/DialogComp';
import AddUpdatePenalty from './addUpdatePenalty';
import { Grid } from '@material-ui/core';
import { DeletePenaltyCharges } from '../../../../../Core/Services/InternalUser/ControllerService/penaltyCharges-Service';
import { useToast } from '../../../../../Core/Hooks/useToast';
import ConfirmationModal from '../../../../../Core/Modal/ConfirmationModal';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import PenaltyChargesNotes from './notesModal';
import { Alert } from '@material-ui/lab';
import CommentIcon from '@material-ui/icons/Comment';
import { CustomIconButton } from '../../../../../Core/Controls/Inputs/Buttons/ButtonModal';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Penalty Charges', path: '/', active: true }
];

const basecolumns = [
    { key: 'action', name: 'Action', width: 130, addFileUploaderIcon: true },
    { key: 'ref', name: 'Reference', width: 150 },
    { key: 'authority', name: 'Issuing Authority', width: 150 },
    { key: 'description', name: 'Description', width: 350 },
    { key: 'offenceDate', name: 'Offence Date', formatter: formatters.Date_DDMMYYYY, width: 100 },
    {
        key: 'dateReceived',
        name: 'Date Received',
        formatter: formatters.Date_DDMMYYYY,
        width: 120
    },
    {
        key: 'appealDate',
        name: 'Appeal Date',
        formatter: formatters.Date_DDMMYYYY,
        width: 120
    },
    {
        key: 'appealEndDate',
        name: 'Appeal End Date',
        formatter: formatters.Date_DDMMYYYY,
        width: 120
    },
    { key: 'cost', name: 'Cost', width: 120 },
    { key: 'driver', name: 'Driver', width: 100 },
    { key: 'status', name: 'Status', width: 120 }
];

const PenaltyCharges = (props) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();
    const history = useHistory();

    const query = useQuery();
    const statusParam = query.get('status');

    useEffect(() => {
        const filterKey = '/controller/PenaltyCharges'; // Change this if your route is different
        const existingFilters = JSON.parse(localStorage.getItem('_GijgoFiltterParams_') || '{}');

        // Only update if params exist
        if (statusParam) {
            existingFilters[filterKey] = {
                ...(existingFilters[filterKey] || {}),
                ...(statusParam ? { status: statusParam } : {})
            };

            localStorage.setItem('_GijgoFiltterParams_', JSON.stringify(existingFilters));
        }
    }, [statusParam]);

    const [state, setState] = React.useState({
        showDetails: false,
        selectedRegNo: props.regNumber,
        formMode: 'add',
        selectedRow: null
    });

    const handleDeletePenalty = async (row) => {
        let res = await DeletePenaltyCharges(state.selectedRow.penaltyChargeID);
        if (res.success) {
            showToastSuccess('Penalty Deleted Successfully');
            setState((st) => ({ ...st, isReload: true, selectedRow: null, showCancelConfirmModal: false }));
        } else {
            showToastError(res.message);
        }
    };
    const handleDeleteModal = async (row) => {
        setState((st) => ({ ...st, showCancelConfirmModal: true, selectedRow: row }));
    };
    const handleNotesModal = async (row) => {
        setState((st) => ({ ...st, showNotesModal: true, selectedRow: row }));
    };

    const handleEditModal = async (row) => {
        setState((st) => ({
            ...st,
            showDetails: true,
            selectedRegNo: row.regno,
            // title: `Update Penalty - ${row.regno}`,
            formMode: 'edit',
            selectedRow: row,
            selectedVehicleID: row.penaltyChargeVehicleID
        }));
    };

    const actionButton = (data, row) => {
        return (
            <Grid container justify="space-evenly">
                <EditButton onClick={() => handleEditModal(row)} toolTipTitle="Edit Penalty" />
                <DeleteButton onClick={() => handleDeleteModal(row)} toolTipTitle="Delete Penalty" />
                {/* <DeleteButton onClick={() => handleNotesModal(row)} toolTipTitle="Penalty Notes" /> */}
                <CustomIconButton icon={CommentIcon} onClick={() => handleNotesModal(row)} toolTipTitle="Penalty Notes" />
            </Grid>
        );
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.key === 'action');
        if (actionCol) {
            actionCol.formatter = actionButton;
        }
        if (!props.VehicleID) {
            tempCols.splice(8, 0, { key: 'regno', name: 'Reg Number', width: 110 });
        }

        return tempCols;
    }, []);

    const handleModalClose = (flag) => {
        setState((st) => ({ ...st, showDetails: false, selectedRow: null, showCancelConfirmModal: false, showNotesModal: false }));
        flag && setState((st) => ({ ...st, isReload: true }));
    };

    const addModalHandle = () => {
        setState((st) => ({
            ...st,
            showDetails: true,
            formMode: 'add',
            selectedVehicleID: props.VehicleID || '',
            selectedRegNo: props.regNumber
            // title: `Add Penalty - ${props.regNumber}`
        }));
    };

    const WarningModalTitle = () => {
        return (
            <Grid container justify="space-between">
                <Grid item xs={12}>
                    <Grid container spacing={2} justify="space-between">
                        <Grid item xs={6}>
                            <span>Ref: {state.selectedRow.ref}</span>
                        </Grid>
                        <Grid item xs={6}>
                            <span>Reg No: {state.selectedRow.regno}</span>
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: '10px' }}>
                            Description: {state.selectedRow.description}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Alert color="warning">Are you sure do you want to delete penalty</Alert>
                </Grid>
            </Grid>
        );
    };
    const NotesTitle = () => {
        return (
            <Grid container justify="space-">
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <span>Notes</span>
                        </Grid>
                        <Grid item xs={2}>
                            <span>{state.selectedRow.ref}</span>
                        </Grid>
                        <Grid item xs={8}>
                            <span>{state.selectedRow.description}</span>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <div className={props.VehicleID || props.driverID ? '' : 'screen'} style={{ marginTop: 8 }}>
            <Grid container>
                {!props.VehicleID && !props.driverID && (
                    <Grid item xs={12}>
                        <BreadCrumbs crumbs={crumbs} />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <GijgoGrid
                        columns={columns}
                        dataConverter={(res) => ({
                            records: res.data.list,
                            total: res.data.total
                        })}
                        btnTitle={`${props.VehicleID || props.driverID ? 'Add Penalty' : ''}`}
                        onBtnClick={addModalHandle}
                        isReload={state.isReload}
                        getUrl={`PenaltyCharges/PenaltyCharges_List${props.VehicleID ? `?VehicleID=${props.VehicleID}` : ''}${
                            props.driverID ? `?DriverID=${props.driverID}` : ''
                        }`}
                        idFieldName="penaltyChargeID"
                        fileUploaderConfigName="PenaltyChargesScreen"
                    />
                </Grid>
            </Grid>
            {state.showDetails && (
                <DialogComp
                    title={state.formMode == 'add' ? `Add Penalty ${state.selectedRegNo || ''}` : `Update Penalty ${state.selectedRegNo || ''}`}
                    open={state.showDetails}
                    onClose={() => handleModalClose(false)}
                    maxWidth="md"
                >
                    <AddUpdatePenalty
                        driverID={props.driverID}
                        VehicleID={state.selectedVehicleID}
                        selectedRow={state.selectedRow}
                        selectedRegNo={state.selectedRegNo}
                        onClose={handleModalClose}
                    />
                </DialogComp>
            )}
            {state.showCancelConfirmModal ? (
                <DialogComp title={'Warning'} onClose={() => handleModalClose(false)} maxWidth="sm" fullWidth>
                    <ConfirmationModal message={WarningModalTitle()} handleSubmit={handleDeletePenalty} handleCancel={() => handleModalClose(false)} />
                </DialogComp>
            ) : null}
            {state.showNotesModal ? (
                <DialogComp title={NotesTitle()} onClose={() => handleModalClose(false)} maxWidth="md" fullWidth>
                    <PenaltyChargesNotes chargeID={state.selectedRow?.penaltyChargeID} />
                    {/* <p>opopo</p> */}
                </DialogComp>
            ) : null}
        </div>
    );
};

export default PenaltyCharges;
